import {
  STORAGE_TYPES, DATABASE_TYPES, PRICE_CATEGORIES, MONTH_HOUR_MULTIPLIER,
} from '../constant';
import { getSessionKey } from './utils';

export const getEstimatedPriceForTemplate = ({
  templateID, databaseType = DATABASE_TYPES.MONGODB, instances = 1, shards = 1,
}) => {
  try {
    const currency = getSessionKey('userCurrency') || 'EUR';
    const { PER_HOUR: hourlyRate, PER_MONTH: monthlyRate } = PRICE_CATEGORIES.TEMPLATE_PRICES[databaseType][templateID][currency];

    return {
      monthlyRate: monthlyRate * instances * shards,
      hourlyRate: hourlyRate * instances * shards,
    };
  } catch (error) {
    return {
      monthlyRate: 0,
      hourlyRate: 0,
    };
  }
};

export const getEstimatedPriceForDatabase = ({
  cores = 0, ram = 0, storageSize = 0, storageType = STORAGE_TYPES.HDD, databaseType = DATABASE_TYPES.MONGODB, instances = 0, shards = 1, templateID,
}) => {
  try {
    if (templateID) {
      return getEstimatedPriceForTemplate({
        templateID, instances, databaseType, shards,
      });
    }
    const currency = getSessionKey('userCurrency') || 'EUR';
    const priceCategory = PRICE_CATEGORIES.DATABASE[currency][databaseType];

    const getHourlyRate = (resource) => (
      typeof resource !== 'object' ? 0 : (resource.PER_HOUR !== undefined ? resource.PER_HOUR : resource.PER_MONTH / MONTH_HOUR_MULTIPLIER)
    );
    const getMonthlyRate = (resource) => (
      typeof resource !== 'object' ? 0 : (resource.PER_MONTH !== undefined ? resource.PER_MONTH : resource.PER_HOUR * MONTH_HOUR_MULTIPLIER)
    );

    const monthlyRate = (Math.ceil(
      ((getMonthlyRate(priceCategory.core) * cores * instances * shards)
        + (getMonthlyRate(priceCategory.ram) * ram * instances * shards)
        + (getMonthlyRate(priceCategory.storage[storageType]) * storageSize * instances * shards)) * 100,
    ) / 100).toFixed(2);
    const hourlyRate = (Math.ceil(
      ((getHourlyRate(priceCategory.core) * cores * instances * shards)
        + (getHourlyRate(priceCategory.ram) * ram * instances * shards)
        + (getHourlyRate(priceCategory.storage[storageType]) * storageSize * instances * shards)) * 100,
    ) / 100).toFixed(2);

    return {
      monthlyRate: Number.isNaN(monthlyRate) ? 0 : monthlyRate,
      hourlyRate: Number.isNaN(hourlyRate) ? 0 : hourlyRate,
    };
  } catch (error) {
    return {
      monthlyRate: 0,
      hourlyRate: 0,
    };
  }
};
